import React, { useState, useEffect } from 'react';
import './index.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Team from './pages/Team';
import Shows from './pages/Shows';
import Workshops from './pages/Workshops';
import BoxOffice from './pages/BoxOffice';
import Contact from './pages/Contact';

const pages = {
  '#home': Home,
  '#team': Team,
  '#shows': Shows,
  '#workshops': Workshops,
  '#boxoffice': BoxOffice,
  '#contact': Contact,
};

export default function App() {
  const [activePage, setActivePage] = useState('#home');
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [displayPage, setDisplayPage] = useState('#home');

  const navigateTo = (href) => {
    if (href === activePage) return;
    setIsTransitioning(true);
    setTimeout(() => {
      setDisplayPage(href);
      setActivePage(href);
      setIsTransitioning(false);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 300);
  };

  const PageComponent = pages[displayPage] || Home;

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Navbar active={activePage} onNav={navigateTo} isHomePage={activePage === '#home'} />

      <main
        style={{
          flex: 1,
          paddingTop: activePage === '#home' ? 0 : '80px',
          opacity: isTransitioning ? 0 : 1,
          transform: isTransitioning ? 'translateY(12px)' : 'translateY(0)',
          transition: 'opacity 0.3s ease, transform 0.3s ease',
        }}
      >
        <PageComponent />
      </main>

      <Footer />
    </div>
  );
}
